import * as React from 'react';
import { SVGProps } from 'react';

const SvgHideOutlined = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" role="img" {...props}>
    <path
      d="M15.384 5.758A8.011 8.011 0 0 0 12 5C9.067 5 6.823 6.626 5.372 8.129a14.95 14.95 0 0 0-2.102 2.774 8.833 8.833 0 0 0-.145.26l-.01.017-.002.006-.001.002s-.001.001.888.46l-.889-.459a1 1 0 0 0 0 .916v.002l.002.002.003.005.009.017a4.794 4.794 0 0 0 .145.26 14.946 14.946 0 0 0 2.404 3.077l1.414-1.414a12.942 12.942 0 0 1-1.933-2.407A12.944 12.944 0 0 1 6.81 9.518C8.086 8.198 9.842 7 12 7c.652 0 1.267.11 1.844.298l1.54-1.54ZM10.661 16.138c.427.1.874.156 1.339.156 2.158 0 3.914-1.198 5.19-2.518a12.947 12.947 0 0 0 1.654-2.129 12.972 12.972 0 0 0-1.61-2.082l1.322-1.322c.031-.031.061-.063.09-.096a14.954 14.954 0 0 1 2.084 2.756 9.016 9.016 0 0 1 .145.26l.01.017.002.006.002.002-.889.46c.889.457.888.459.888.459v.002l-.004.005-.009.017a5.84 5.84 0 0 1-.145.26 14.94 14.94 0 0 1-2.102 2.774c-1.451 1.503-3.695 3.13-6.628 3.13a7.93 7.93 0 0 1-2.93-.565l1.591-1.592Z"
      fill="currentColor"
    />
    <path d="m20 11.647.889.458c.148-.287.148-.63 0-.917l-.889.46Z" fill="currentColor" />
    <rect
      x={18.364}
      y={4.222}
      width={2}
      height={20}
      rx={1}
      transform="rotate(45 18.364 4.222)"
      fill="currentColor"
    />
  </svg>
);

export default SvgHideOutlined;
